<template>
  <div class="search-form" :style="isDisabled ? 'opacity: 0.8;' : 'opacity: 1;'">
    <div style="position: relative; text-align: end; margin-right: 16px;" v-if="!showIntercomInfo">
      <v-btn
        style="border-radius: 16px"
        @click="toggleSearch"
      >
        <v-icon style="cursor: pointer;">{{ showSearch ? 'mdi-arrow-right-thick' : 'mdi-arrow-left-thick' }}</v-icon>
      </v-btn>
    </div>
    <form @submit.prevent  v-if="showSearch">
      <v-row class="ma-1 pr-3">
        <h1 style="margin-left: 20px; padding-top: 5px">Поиск</h1>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="isComplexMap"
              color="info"
              style="border-radius: 16px"
              v-bind="attrs"
              v-on="on"
              @click="search"
              @keydown.enter="search"
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
          <span>Поиск по карте</span>
        </v-tooltip>
      </v-row>
      <v-col class="px-5 pb-2">
        <v-text-field
          :placeholder="textPlaceholder"
          v-model="filterAddress"
          :disabled="isDisabled"
          prepend-inner-icon="mdi-magnify"
          @input="searchAddress"
          @blur="updateMap"
          @keydown.enter="search"
          solo
          outlined
          dense
          hide-details
          flat
        ></v-text-field>
      </v-col>
      <v-col class="px-5 pb-0">
        <v-btn
          style="width: 100%"
          class="text-none mb-2"
          :class="{ 'is-active-filters-type' : isActiveFilterType }"
          outlined
          rounded
          @click="activeType">
          Фильтр по типам
        </v-btn>
      </v-col>
      <v-col class="px-5 pt-2">
      <div v-if="isActiveFilterType">
        <v-list-item v-for="item in filterType" :key="item.type" :disabled="item.disabled">
            <v-checkbox
              v-model="selectedTypes"
              @click="searchAddress"
              :value="item.type"
              type="checkbox"
              class="mt-0"
            />
          <div style="height: 43px">
            <v-icon class="">{{ item.icon }}</v-icon>
          {{ item.name }}
          </div>
        </v-list-item>
      </div>
      </v-col>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    isDisabled: {
      type: Boolean,
    },
    isComplexMap: {
      type: Boolean,
      default: false,
    },
    showIntercomInfo: {
      type: Boolean,
      default: true,
    },
    textPlaceholder: {
      type: String,
      default: 'Введите адрес или id',
    },
  },
  data () {
    return {
      filterAddress: '',
      isActiveFilterType: false,
      showSearch: true,
      selectedTypes: ['A', 'M', 'B', 'G'],
      filterType: [
        {
          type: 'M',
          name: 'Домофон',
          icon: 'mdi-map-marker',
          disabled: false,
        },
        {
          type: 'G',
          name: 'Калитка',
          icon: 'mdi-gate-alert',
          disabled: false,
        },
        {
          type: 'A',
          name: 'Доп. вход',
          icon: 'mdi-home-import-outline',
          disabled: false,
        },
        {
          type: 'B',
          name: 'Шлагбаум',
          icon: 'mdi-boom-gate',
          disabled: false,
        },
      ],
    };
  },
  methods: {
    toggleSearch () {
      this.showSearch = !this.showSearch;
    },
    activeType () {
      this.isActiveFilterType = !this.isActiveFilterType;
      this.$emit('activeType', this.isActiveFilterType);
    },
    searchAddress () {
      this.$emit('searchAddress', this.filterAddress, this.selectedTypes);
    },
    search () {
      const isValidAddress = !this.filterAddress || this.filterAddress.length === 0 || this.filterAddress.length >= 4;

      if (!isValidAddress) {
        this.$flash_danger('Введите минимум 4 символов или выберите тип');
        return;
      }
      this.$emit('search', this.filterAddress, this.selectedTypes);
    },
    updateMap () {
      this.$emit('update');
    },
  },
};
</script>

<style lang="scss" scoped>
.search-form {
  position: absolute;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  top: 10px;
  right: 10px;
  //z-index: 10000;
  min-width: 300px;
  padding: 15px 5px;
}

.is-active-filters-type {
  background-color: #313e81;
  color: #FFFFFF;
}

@media screen and (max-width: 400px) {
  .search-form {
    min-width: 0;
    right: 0;
    width: 250px;
    z-index: 0;
  }
}
</style>
